export const SERVICE_TYPE_SECTIONS = {
  Exam: ['exams'],
  Lens: ['lens', 'lab', 'prescription'],
  'Contact Lens': ['contact_lens'],
  'Contact Lens Service': ['contact_lenses_service'],
  Frame: ['frame'],
}

export const CLAIM_SECTION_BY_SERVICE = {
  Exam: 'exam',
  Lens: 'lens',
  'Contact Lens': 'contact_lens',
  'Contact Lens Service': 'contact_lenses_service',
  Frame: 'frame',
}

const ALWAYS_VISIBLE_SECTIONS = [
  'basic_info',
  'insured',
  'patient',
  'additional_information',
  'facility_and_billing_information',
]

export const getVisibleSections = (eligibilityData = []) => {
  const sections = [...ALWAYS_VISIBLE_SECTIONS]

  eligibilityData.forEach(({ active, service_type: serviceType }) => {
    if (!active) return

    ;(SERVICE_TYPE_SECTIONS[serviceType] || []).forEach((section) => {
      if (!sections.includes(section)) sections.push(section)
    })
  })

  return sections
}

export const shouldShowClaimSection = (sectionName, eligibilityData = []) => (
  getVisibleSections(eligibilityData).includes(sectionName)
)

export const getClaimSectionsForPayload = (eligibilityData = []) => {
  const sections = []

  eligibilityData.forEach(({ active, service_type: serviceType }) => {
    if (!active) return

    const section = CLAIM_SECTION_BY_SERVICE[serviceType]
    if (section && !sections.includes(section)) sections.push(section)
  })

  return sections
}
